export default "__VITE_ASSET__BpN041Yy__"